import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS } from "@/store/actions";

import Vue from "vue";

const state = {
  status: "booting",
  people: {},
  person: {},
  message: "",
  errors: [],
  currentId: null,
  currentPerson: {},
  searchResults: {},
  currentPharmacist: {},
  currentPersonCert: {},
  currentPersonAddresses: [],
  currentPersonScopeOfPRactice: {},
  currentProfile: {}
};
const getters = {};

const actions = {
  async selectPharmacist({ commit }, personId) {
    commit("setCurrentPersonId", personId);
    try {
      var personProfileData = await Vue.axios.get(
        "practitioners/" + personId + "/profile"
      );
      console.log(personProfileData);
      if (personProfileData.data) {
        commit("setCurrentPerson", personProfileData.data);
      }
    } catch (e) {
      throw e;
    }
  }
  // async selectPerson({ commit }, personId) {
  //   /*commit("setCurrentPersonId", personId);
  //   var personData = await Vue.axios.get("people/" + personId);
  //   var pracData = await Vue.axios.get("practitioners/" + personId);
  //   if (personData.data && pracData.data) {
  //     commit("setCurrentPharmacist", {
  //       ...personData.data,
  //       ...pracData.data
  //     });
  //   }*/
  // }
};

const mutations = {
  setCurrentPersonId: (state, personId) => {
    state.currentId = personId;
  },
  setCurrentPerson: (state, profileData) => {
    state.currentProfile = { ...profileData };
    state.currentPerson = profileData.person;
    state.currentPharmacist = {
      ...profileData.person,
      ...profileData.practitioner
    };
    state.currentPersonCert = profileData.person;
    state.currentPersonAddresses = profileData.person.addresses;
    state.CurrentPersonScopeOfPRactice = profileData.scopeofpractice;
  },
  setCurrentPharmacist: (state, pharmData) => {
    // state.currentPharmacist = pharmData;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
